import React, { useEffect, useState } from "react";
import { HiPlus } from "react-icons/hi";
import { Button, Container } from "reactstrap";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";
import AdminManageGST from "../Modal/ManageGST/AdminManageGST";
import { MdOutlineEdit } from "react-icons/md";
import { FiTrash } from "react-icons/fi";
import toast from "react-hot-toast";
import {
  getServices,
  postServices,
  updateServices,
} from "../../../../apiServices/apiServices";
import LoadingSpinner from "../common/LoadingSpinner";

function ManageGSTView() {
  const [modal, setModal] = useState({ add: false, update: false });
  const [fieldData, setFieldData] = useState({
    tax_name: "",
    cgst: "",
    sgst: "",
    isEdit: false,
  });
  const [slabList, setSlabList] = useState([]);
  const [loading, setLoading] = useState({ page: false, btn: false });
  const access_token = sessionStorage.getItem("access-token");

  useEffect(() => {
    if (navigator.onLine) {
      fetchGSTSlabList();
    }
  }, [navigator]);

  const fetchGSTSlabList = async () => {
    setLoading({ ...loading, page: true });

    try {
      const res = await getServices(`/api/tax/list`, access_token);

      setLoading({ ...loading, page: false });
      if (res.responseCode === 200) {
        setSlabList(res.responseData);
      } else {
        setSlabList([]);
        toast.error(res.responseMessage || "Something went wrong");
      }
    } catch (error) {
      setLoading({ ...loading, page: false });
      toast.error(error || "Something went wrong");
    }
  };

  const handleAddGSTModal = () => {
    setModal({ ...modal, add: true, update: false });
    setFieldData({
      ...fieldData,
      tax_name: "",
      cgst: "",
      sgst: "",
      isEdit: false,
    });
  };

  const handleUpdateModal = (tax_info) => {
    setModal({ ...modal, update: true, add: false });
    setFieldData({
      ...fieldData,
      tax_id: tax_info.tax_id,
      tax_name: tax_info.tax_name,
      cgst: tax_info.cgst,
      sgst: tax_info.sgst,
      isEdit: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading({ ...loading, btn: true });
    const urlencoded = new URLSearchParams();

    urlencoded.append("tax_name", fieldData.tax_name);
    urlencoded.append("cgst", fieldData.cgst);
    urlencoded.append("sgst", fieldData.sgst);

    let res;

    try {
      if (fieldData.isEdit) {
        res = await updateServices(
          `/api/tax/edit?tax_id=${fieldData.tax_id}`,
          access_token,
          urlencoded
        );
      } else {
        res = await postServices(`/api/tax/create`, access_token, urlencoded);
      }
      setLoading({ ...loading, btn: false });

      if (res.responseCode === 200) {
        setModal({ ...modal, add: false, update: false });
        fetchGSTSlabList();
        toast.success("Tax slab added..!");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setLoading({ ...loading, btn: false });
      toast.error(error || "Something went wrong");
    }
  };

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <Container className="flex justify-between items-center mx-0 px-4 py-8 sm:p-8">
            <p className="text-2xl font-semibold">Manage GST Slab</p>
            <Button
              onClick={handleAddGSTModal}
              className="bg-slate-800 flex items-center px-7 py-2 text-white font-semibold rounded-xl outline-none border-none active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
            >
              <HiPlus className="mr-2" />
              Add GST Slab
            </Button>
          </Container>

          {!loading.page ? (
            <Container className="mx-4 sm:mx-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {slabList.length > 0 ? (
                slabList.map((tax, i) => (
                  <Container
                    key={i}
                    className="border border-[#80000077] shadow-xl p-4 rounded-xl"
                  >
                    <Container className="flex justify-end items-center gap-3">
                      <MdOutlineEdit
                        onClick={() => handleUpdateModal(tax)}
                        className="text-3xl cursor-pointer bg-[#80000014] rounded-full p-1 border border-[#80000064]"
                      />
                      {/* <FiTrash className="text-3xl cursor-pointer bg-[#80000014] rounded-full p-1 border border-[#80000064]" /> */}
                    </Container>

                    <p className="text-xl font-semibold mb-2">{tax.tax_name}</p>
                    <p className="font-semibold text-sm">
                      CGST:{" "}
                      <span className="font-normal text-gray-500">
                        {tax.cgst}
                      </span>
                    </p>
                    <p className="font-semibold text-sm">
                      SGST:{" "}
                      <span className="font-normal text-gray-500">
                        {tax.sgst}
                      </span>
                    </p>
                  </Container>
                ))
              ) : (
                <Container className="flex justify-center items-center min-h-[25vh] col-span-full">
                  <p className="font-semibold">No Slab Found...</p>
                </Container>
              )}
            </Container>
          ) : (
            <Container className="flex items-center justify-center mt-52">
              <LoadingSpinner />
            </Container>
          )}
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}

      <AdminManageGST
        open={modal.add}
        onClose={() => setModal({ ...modal, add: false })}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      <AdminManageGST
        open={modal.update}
        onClose={() => setModal({ ...modal, update: false })}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleSubmit={handleSubmit}
        loading={loading}
      />
    </>
  );
}

export default ManageGSTView;
